import React from 'react'

import S from './styled'

import  { WarningIcon } from '../icons'

const Error = ({ error }) => (
  <S.Error>
    <WarningIcon />
    <S.ErrorMessage>{error || 'Something went wrong...'}</S.ErrorMessage>
  </S.Error>
)

export default Error
